import { api } from '../../../redux/services/api';

const authHeaders = token => ({ Authorization: `Bearer ${token}` });

export const queueDashboardApi = api.injectEndpoints({
  endpoints: build => ({
    // GET /api/queue-dashboard  (polled every 2s while focused)
    getQueueDashboard: build.query({
      query: ({ token }) => ({
        url: 'api/queue-dashboard',
        method: 'GET',
        headers: authHeaders(token),
      }),
      providesTags: ['QueueDashboard'],
    }),
  }),
});

export const { useGetQueueDashboardQuery } = queueDashboardApi;
